import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RejectTicketPopupData {
  ticketId: string;
  binderName: string;
  ticketUserId?: number;
  ticketUserName?: string;
  supportTicketId: number;
  sku?: string;
  nfcCryptoId?: string;
  vaultxBinderNo?: number;
  isOtherCategory?: boolean;
}

@Component({
  selector: 'app-reject-ticket-confirmation-popup',
  standalone: false,
  templateUrl: './reject-ticket-confirmation-popup.html',
  styleUrls: ['./reject-ticket-confirmation-popup.scss']
})
export class RejectTicketConfirmationPopup {
  ticketId: string;
  binderName: string;
  sku: string;
  nfcCryptoId: string;
  vaultxBinderNo: number | null;
  adminNotes: string = '';
  isOtherCategory: boolean = false;

  constructor(
    private readonly dialogRef: MatDialogRef<RejectTicketConfirmationPopup>,
    @Inject(MAT_DIALOG_DATA) public data: RejectTicketPopupData
  ) {
    this.ticketId = data.ticketId ;
    this.sku = data.sku ;
    this.nfcCryptoId = data.nfcCryptoId ;
    this.vaultxBinderNo = data.vaultxBinderNo ;
    this.binderName = data.binderName.trim();
    this.isOtherCategory = !!data.isOtherCategory;
  }

  close(): void {
    this.dialogRef.close({ confirm: false });
  }

  confirmRejection(): void {
    this.dialogRef.close({
      confirm: true,
      adminNotes: this.adminNotes?.trim() || ''
    });
  }
}
